import { HealthcareIndustryPageProvider } from "../../context/industryPageProviders";
import IndustryPageLayout from "./IndustryPageLayout";

export default function Healthcare() {
  return (
    <HealthcareIndustryPageProvider>
      <IndustryPageLayout />
    </HealthcareIndustryPageProvider>
  );
}
